module.exports = __webpack_public_path__ + "img/nomeaasge.40c5cde8.png";